module.exports = __webpack_public_path__ + "img/dne-market.dc9e43b4.png";